const { initCookieRevokeContrast } = require('./src/helpers/cookieRevokeContrast')
const { createGatsbyBrowserHooks } = require('./src/helpers/gatsbyBrowserHooks')

const { onClientEntry, onRouteUpdate } = createGatsbyBrowserHooks(initCookieRevokeContrast)

exports.onClientEntry = onClientEntry
exports.onRouteUpdate = onRouteUpdate
